<template lang="pug">
  div(@click="onFloatActionButton").wrap-float-action-button.f.fh
    v-icon(color="#FFF") edit
</template>

<style lang="scss" scoped>
.wrap-float-action-button {
  position: fixed;
  z-index: 999;
  right: 12px;
  bottom: 12px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ff9999;
  filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.1));
}
</style>

<script>

import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')

export default {
  computed: {
    ...mapStateAuth(['uid', 'isAnonymous'])
  },
  methods: {
    onFloatActionButton () {
      if (this.uid && !this.isAnonymous) {
        // TO DO: userのavatarに基づいて$router.pushする。
        this.$router.push('/post/minna_ai')
      } else {
        var toSignUp = confirm('ミンナアイになってくれませんか？ミンナアイになるとミンナアイとしてツイートできます。')
        if (toSignUp) {
          this.$router.push('/sign-up')
        }
      }
    }
  }
}
</script>
